import { useEffect, useState } from "react";
import { Input, Modal } from "antd";

export default function RenameItemModal({ open, item, onClose, onRename }) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setName(item?.name || "");
      setError("");
      setSaving(false);
    }
  }, [open, item]);

  const handleOk = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError("Enter a name.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await onRename(trimmed);
    } catch (requestError) {
      setError(
        requestError?.response?.data?.error || "Could not rename. Try again."
      );
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      title={`Rename ${item?.type === "folder" ? "folder" : "file"}`}
      onCancel={saving ? undefined : onClose}
      onOk={handleOk}
      okText="Rename"
      confirmLoading={saving}
      destroyOnHidden
    >
      <Input
        autoFocus
        value={name}
        onChange={(event) => {
          setName(event.target.value);
          setError("");
        }}
        onPressEnter={handleOk}
      />
      {error && (
        <div role="alert" style={{ marginTop: 10, color: "#b42318", fontSize: 13 }}>
          {error}
        </div>
      )}
    </Modal>
  );
}
